enum API {
	LOGIN = '/auth/login',
	REGISTER = '/auth/register',
	CONFIRM = '/auth/confirm',
	RESET_PASSWORD = '/auth/resetPassword/'
}

export default API;
